<template>
  <div class="page-class page-vision-form">
    <h1 class="page-title">{{ title }}</h1>
    <vision-form-box
      list-url="/vision"
      vision-type="vision"
      :form-type="formType"
      :vision-id="visionId"
      @add="onAdd"
      @edit="onEdit"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VisionFormBox from '@/components/VisionFormBox.vue';
import router from '@/router';

export default {
  name: 'VisionForm',
  components: {
    VisionFormBox
  },
  async mounted() {
    if (this.$route.name === 'vision-new') {
      this.formType = 'new';
      this.visionId = null;
    } else {
      this.formType = 'update';
      this.visionId = parseInt(this.$route.params.id, 10);
      await this.getOne({
        type: 'vision',
        visionId: this.visionId,
        router
      });
    }
  },
  data() {
    return {
      formType: '',
      visionId: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add new vision' : 'Update vision';
    },
    ...mapState('vision', ['loading'])
  },
  methods: {
    ...mapActions('vision', ['getOne', 'postOne', 'patchOne']),
    onAdd({ vision }) {
      this.postOne({
        type: 'vision',
        vision,
        router,
        redirectUrl: '/vision'
      });
    },
    onEdit({ vision }) {
      this.patchOne({
        type: 'vision',
        visionId: this.visionId,
        vision,
        router,
        redirectUrl: '/vision'
      });
    }
  }
};
</script>
